// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"465":"e44d858e","498":"1b9b0515","703":"a8c3847e"}[chunkId] + ".chunk.js";
};